import { render, staticRenderFns } from "./PublicTopNavbar.vue?vue&type=template&id=3fe4ffad&"
import script from "./PublicTopNavbar.vue?vue&type=script&lang=js&"
export * from "./PublicTopNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports